import template from './rooms-for-rent-count-daily.jade';

export default angular
  .module('cian.addForm.roomsForRentCountDaily', [])
  .directive('cianAfAboutObjectRoomsForRentCountDaily', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {},
    controllerAs: 'roomsForRentCountDaily',
    template,
  })).name;
